var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('HomeBanner',{attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }